import React, { useEffect, useState } from 'react';
import { app_bank_accounts } from '../services/common';





const ExternalBanks = () =>{

    const [banks, setBanks] = useState([]);
    const [loading, setLoading] = useState(false);
    const fetchBanks = async () => {
        setLoading(true);
        const token = localStorage.getItem('systemToken');
        const response = await app_bank_accounts(token);
        setBanks(response.bank_accounts);
        setLoading(false)
    }


    useEffect(() => {
        fetchBanks();
    },[])


    return (
        <>
         <div className="lg:min-w-[78vw] lg:max-w-[80vw] pt-0">
            {loading && (
                <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
                    <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin">
                        
                    </div>
                </div>
            )}
            <div className="w-full mt-4 mb-2 p-4 bg-white rounded-lg shadow-lg">
                <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
                    <div className="flex items-center">
                        <img src="/money-receive.svg" alt="Company Logo" className="mr-3" />
                        <span className="font-medium lg:text-xl text-sm">
                            External Banks
                        </span>
                    </div>
                </div>
                <div className="flex justify-between flex-wrap mb-4 gap-4 mb-4">         
                    {banks.map((ac) => (
                        <div key={ac.bank_id} className=" col-md-12 px-4 my-2 border-b border-gray-300">
                        <div>
                            <button className="btn btn-dark pw4 font-size-10 text-uppercase bg-black text-white">
                            {ac.currency_symbol} {ac.currency}
                            </button>
                            <b className="text-lg pl-2">
                            {ac.bank_name} - {ac.bank_account_no}
                            </b>
                        </div>
                        <div className="mt-2 text-sm">
                            {ac.bank_bsb && (
                            <p className="text-gray-600 leading-tight">
                                BSB: <span className="font-bold">{ac.bank_bsb}</span>
                            </p>
                            )}
                            <p className="text-gray-600 leading-tight">
                            SwiftCode: {ac.bank_swift_code}
                            </p>
                            <p className="text-gray-600 leading-tight">
                            Address: {ac.bank_address}
                            </p>
                        </div>
                        </div>
                    ))}
                </div>      
            </div>       
            </div> 
        </>
    );


};


export default ExternalBanks;



